<template>
  <div class="full-height">
    <v-row justify="center" align="center" class="full-width" no-gutters>
      <v-col cols="12" sm="7" md="8" lg="7" xl="7">
        <div class="rounded-lg">
          <v-card v-if="survey !== null" class="main-card text-left" elevation="0" rounded="2">
            <div class="main-card-content">
              <Survey
                :survey="survey"
                :displayName="survey.displayName"
                :completedStatus="surveyCompleted"
                showBackButton
                :postLearningLog="preview ? null : postLearningLog"
                :preview="preview"
                @surveyCompleted="handleSurveyCompleted"
                @back="leaveCourse"
                @exit="leaveCourse"
                @retakeSurvey="surveyCompleted = false"
                @update-completed="surveyCompleted = $event"
              />
            </div>
          </v-card>
          <v-card
            class="main-card skeleton-div py-16 px-8"
            elevation="0"
            rounded="2"
            v-else-if="loadingSurvey && !moduleNotFound"
          >
            <div>
              <v-skeleton-loader class="mb-3 ml-4" type="heading"></v-skeleton-loader>
            </div>
            <div>
              <v-skeleton-loader class="mt-1" type="list-item"></v-skeleton-loader>
              <v-skeleton-loader class="mt-1" type="list-item"></v-skeleton-loader>
            </div>
          </v-card>
          <v-card
            v-else-if="moduleNotFound"
            class="d-flex main-card skeleton-div flex-column align-center px-4 py-16 word-break"
            elevation="0"
            rounded="2"
          >
            <div class="mx-auto mt-18">
              <Robin
                :height="100"
                :width="100"
                :largeText="true"
                :showText="false"
                animation="curious"
                :loop="true"
              ></Robin>
            </div>
            <h2 class="mt-2">We had trouble finding your survey</h2>

            <v-btn
              depressed
              rounded
              color="brandCyan"
              @click="leaveCourse"
              class="mt-6 mx-5 white--text"
              width="180"
              >Go to Programs</v-btn
            >
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LearningService from "@/services/LearningService";

import Survey from "@/components/learning/SurveyV3.vue";
import Robin from "@/components/Robin.vue";

import { mapState } from "vuex";

import confettiMixin from "@/mixins/confettiMixin";

export default {
  name: "SurveysPrivateV2",
  mixins: [confettiMixin],
  title: "Surveys",
  components: {
    Survey,
    Robin,
  },
  props: {
    surveyId: {
      default: null,
      type: String,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    sourcePage: {
      default: null,
      type: String,
    },
    sourcePageId: {
      default: null,
      type: String,
    },
    preview: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      survey: null,
      loadingSurvey: false,
      surveyCompleted: false,
      moduleNotFound: false,
    };
  },
  mounted() {
    this.getModule();
  },
  methods: {
    getModule() {
      this.loadingSurvey = true;
      LearningService.getSurveyContent(this.surveyId, this.preview)
        .then((modules) => {
          if (modules.length > 0) {
            const module = JSON.parse(JSON.stringify(modules))[0];

            (module.LearningChapters || []).forEach((ch) => {
              ch.LearningCards.sort((a, b) => (a.order || 0) - (b.order || 0));
            });

            this.survey = module;
          } else {
            this.moduleNotFound = true;
          }
        })
        .catch(() => {
          this.moduleNotFound = true;
        })
        .finally(() => {
          this.loadingSurvey = false;
        });
    },
    handleSurveyCompleted() {
      this.surveyCompleted = true;
      this.playConfettiSimple();
    },
    async postLearningLog(card, options = {}) {
      const { returnLog = false, extraLogs = [] } = options;

      const body = {
        userId: this.userProfile.userId,
        clientId: this.userProfile.clientId,
        learningCardId: card.learningCardId,
        learningCardAssociationId: card.learningCardAssociationId,
        completed: true,
        completedDate: new Date(),
        learnerRating: null,
        learnerConfidence: null,
        score: null,
      };

      const logs = [...extraLogs, body];

      if (returnLog) {
        return logs;
      }

      await LearningService.createLearningLog(
        logs,
        (this.survey && this.survey.AssociatedPrograms) || []
      );
    },
    leaveCourse() {
      if (this.preview) return;
      if (this.sourcePage && this.sourcePage === "programs") this.$router.back();
      else
        this.$router.push({
          name: "programs",
          query: {
            filterBy: "surveys",
          },
        });
    },
  },
  computed: {
    ...mapState(["userProfile"]),
  },
};
</script>

<style scoped>
.skeleton-div {
  max-width: 60vw;
}
@media only screen and (max-width: 600px) {
  .skeleton-div {
    max-width: 75vw;
  }
}

/* V2 */
.main-card {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 10px 10px 10px 10px !important;
}

.main-card-content {
  min-width: 60%;
  height: 100%;
  min-height: 60vh;
  padding-top: 40px;
  padding-bottom: 40px;
}
@media screen and (min-width: 960px) {
  .main-card-content {
    margin-left: 10%;
    margin-right: 10%;
  }
}
@media screen and (min-width: 451px) {
  .main-card-content {
    margin-left: 20px;
    margin-right: 20px;
  }
}
@media screen and (max-width: 450px) {
  .main-card-content {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
